import React, { useEffect, useState, useContext } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Button,IconButton, Select, MenuItem } from '@mui/material';
import { Add,Download } from '@mui/icons-material';
import { AuthContext } from '../auth/AuthContext';
import ProtectedAction from './ProtectedAction';

export default function RichiesteDocumentoNonEvaseTable({ richieste, onCambiaStato, onCreaDocumento, onDownload }) {
      const { user } = useContext(AuthContext);
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Tipo</TableCell>
          <TableCell>Stato</TableCell>
          <TableCell>Note</TableCell>
          <TableCell>Azioni</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {richieste.map((r) => (
          <TableRow key={r.id}>
            <TableCell>{r.tipoDocumento}</TableCell>
            <TableCell>{r.stato}
              {/*<Select
                size="small"
                value={r.stato}
                onChange={(e) => onCambiaStato(r.id, e.target.value)}
              >
                <MenuItem value="RICHIESTO">RICHIESTO</MenuItem>
                <MenuItem value="CARICATO">CARICATO</MenuItem>
                <MenuItem value="VALIDATO">VALIDATO</MenuItem>
              </Select>*/}
            </TableCell>
            <TableCell>{r.note}</TableCell>
            <TableCell>
                  {!r.documentoFascicoloId && (
                     <ProtectedAction user={user} contractState={user.statoContratto}>
                      <Button size="small" color="primary"  onClick={() => onCreaDocumento(r.id,r.tipoDocumento)} startIcon={<Add />}>Carica documento</Button>
                      </ProtectedAction>
                  )}

            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}